module.exports = require("swagger-ui");


//////////////////
// WEBPACK FOOTER
// external "swagger-ui"
// module id = 164
// module chunks = 0